import { Box, CircularProgress, Typography } from '@mui/material'
import { MESSAGES } from '~/components/Charts/chrome/chartChrome'

interface Props {
  /** Smaller min-height for sub-rows (e.g. the Dynamics compare row). */
  compact?: boolean
}

/**
 * First-load placeholder for a chart tile: a height-holding, centered box with a
 * spinner + caption. Holds vertical space so a slow walk fetch does not collapse the
 * card from chart-height to spinner-height. Pure presentational; no data. Sibling of
 * EmptyChartState / WalkError. The inner MUI CircularProgress provides role="progressbar";
 * the wrapper is a role="status" live region carrying aria-busy.
 */
export function ChartLoadingState({ compact = false }: Props) {
  return (
    <Box
      role="status"
      aria-busy
      aria-live="polite"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        py: compact ? 2 : 4,
        minHeight: compact ? 96 : 200,
        color: 'text.secondary',
      }}
    >
      <CircularProgress size={compact ? 24 : 40} />
      <Typography variant="caption">{MESSAGES.chartLoading}</Typography>
    </Box>
  )
}
